import React, { createContext, useContext, useState, useEffect } from 'react';
import { Chart as ChartJS } from 'chart.js';

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem('esx_theme');
    if (saved) return saved === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem('esx_theme', dark ? 'dark' : 'light');

    try {
      const textColor = dark ? '#94a3b8' : '#4a5568';
      const gridColor = dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)';

      ChartJS.defaults.color = textColor;
      if (ChartJS.defaults.scale && ChartJS.defaults.scale.grid) {
        ChartJS.defaults.scale.grid.color = gridColor;
      }
      if (ChartJS.defaults.scales) {
        if (ChartJS.defaults.scales.x && ChartJS.defaults.scales.x.grid) {
          ChartJS.defaults.scales.x.grid.color = gridColor;
        }
        if (ChartJS.defaults.scales.y && ChartJS.defaults.scales.y.grid) {
          ChartJS.defaults.scales.y.grid.color = gridColor;
        }
      }
    } catch (e) {
      console.warn('Error setting Chart.js defaults:', e);
    }
  }, [dark]);

  return (
    <ThemeContext.Provider value={{ dark, toggle: () => setDark(d => !d) }}>
      {children}
    </ThemeContext.Provider>
  );
}
